<div class="row g-md-4">
  <div class="col-md-6">
    <dx-date-box
      [value]="startDate"
      (onValueChanged)="onStartDateChanged($event.value)"
      [min]="minStartDate"
      [max]="getStartDateMax()"
      [label]="startDateLabel || ('COMMON.FIELDS.FROM-DATE' | translate)"
      labelMode="floating"
      stylingMode="outlined"
      displayFormat="d MMMM yyyy"
      type="date"
      [readOnly]="isViewMode"
      [disabled]="disabled"
    >
      <dx-validator #startDateValidator>
        <dxi-validation-rule 
          type="required" 
          [message]="'VALIDATIONS.START-DATE-REQUIRED' | translate"
        ></dxi-validation-rule>
      </dx-validator>
    </dx-date-box>
  </div>

  <div class="col-md-6">
    <dx-date-box
      [value]="endDate"
      (onValueChanged)="onEndDateChanged($event.value)"
      [min]="getEndDateMin()"
      [max]="maxEndDate"
      [label]="endDateLabel || ('COMMON.FIELDS.TO-DATE' | translate)"
      labelMode="floating"
      stylingMode="outlined"
      displayFormat="d MMMM yyyy"
      type="date"
      [readOnly]="isViewMode"
      [disabled]="disabled"
    >
      <dx-validator #endDateValidator>
        <dxi-validation-rule 
          type="required" 
          [message]="'VALIDATIONS.DATE-REQUIRED' | translate"
        ></dxi-validation-rule>
      </dx-validator>
    </dx-date-box>
  </div>
</div>
